import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';
import { Payload } from 'ha/services/apiV2/resetPassword';

import { RecoverPasswordTypes } from '../constants';

export const Actions = {
  start: () => createAction(RecoverPasswordTypes.start),
  done: () => createAction(RecoverPasswordTypes.done),
  fail: () => createAction(RecoverPasswordTypes.fail),
};
export type Actions = ActionsUnion<typeof Actions>;

export const onRecoverPasswordStart = Actions.start;
export const onRecoverPasswordSuccess = Actions.done;
export const onRecoverPasswordFail = Actions.fail;

type SendRecoverPassword = (payload: Payload) => Thunk;

const sendRecoverPasswordRequest: SendRecoverPassword = payload => (
  _,
  __,
  { apiV2 },
) => apiV2.resetPassword(payload).then(() => undefined);

export default sendRecoverPasswordRequest;
